"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/web.dom.iterable");
/**
 * 获取当前层级的所有form组件
 */

var allComponents = require.context('.',
// 在当前目录下查找
false,
// 不遍历子文件夹
/\.vue$/ // 正则匹配 以 .vue结尾的文件
);
var formComps = {};
allComponents.keys().forEach(function (fileName) {
  var comp = allComponents(fileName);
  formComps[fileName.replace(/^\.\/(.*)\.\w+$/, '$1')] = comp.default;
});
var _default = exports.default = formComps;